import { TRANSE_SPOUSTECE, type TranseSpoustec } from '@helfr/domain';
import { TRANSE_SPOUSTEC_LABEL } from '../lib/labels.js';
import { Btn, Input, Select, td, th } from './ui.js';

/** Řádek konfigurace tranše — drátový formát POST/PUT (procento jako string). */
export interface TranseRadek {
  procento: string;
  spoustec: TranseSpoustec;
  odkladMesicu: number;
}

/**
 * Editor tranší pozastávky — konfigurace per smlouva (§0b: 5/2/2/1 je jen
 * výchozí šablona, nikdy hardcode). Používá založení smlouvy i detail.
 */
export function TranseEditor({
  transe,
  onChange,
}: {
  transe: TranseRadek[];
  onChange: (transe: TranseRadek[]) => void;
}) {
  const uprav = (i: number, zmena: Partial<TranseRadek>) =>
    onChange(transe.map((t, j) => (i === j ? { ...t, ...zmena } : t)));

  return (
    <table className="w-full">
      <thead>
        <tr>
          <th className={`${th} w-16`}>Č.</th>
          <th className={`${th} w-32`}>Procento</th>
          <th className={th}>Spouštěč</th>
          <th className={`${th} w-40`}>Odklad (měsíce)</th>
          <th className={`${th} w-32`} />
        </tr>
      </thead>
      <tbody>
        {transe.map((t, i) => (
          <tr key={i}>
            <td className={td}>{i + 1}.</td>
            <td className={td}>
              <Input
                aria-label={`Procento tranše ${i + 1}`}
                inputMode="decimal"
                value={t.procento}
                onChange={(e) => uprav(i, { procento: e.target.value })}
              />
            </td>
            <td className={td}>
              <Select
                aria-label={`Spouštěč tranše ${i + 1}`}
                value={t.spoustec}
                onChange={(e) => uprav(i, { spoustec: e.target.value as TranseSpoustec })}
              >
                {TRANSE_SPOUSTECE.map((s) => (
                  <option key={s} value={s}>
                    {TRANSE_SPOUSTEC_LABEL[s]}
                  </option>
                ))}
              </Select>
            </td>
            <td className={td}>
              <Input
                aria-label={`Odklad tranše ${i + 1} v měsících`}
                type="number"
                min={0}
                value={t.odkladMesicu}
                onChange={(e) => uprav(i, { odkladMesicu: Number(e.target.value) })}
              />
            </td>
            <td className={td}>
              <Btn
                varianta="danger"
                disabled={transe.length <= 1}
                onClick={() => onChange(transe.filter((_, j) => j !== i))}
              >
                Odebrat
              </Btn>
            </td>
          </tr>
        ))}
        <tr>
          <td className={td} colSpan={5}>
            <Btn
              varianta="secondary"
              onClick={() =>
                onChange([...transe, { procento: '', spoustec: 'predani_dila', odkladMesicu: 0 }])
              }
            >
              Přidat tranši
            </Btn>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

/** Součet procent tranší (textově, na 2 des. místa — jen informativní kontrola). */
export function soucetProcent(transe: TranseRadek[]): string {
  const soucetSetin = transe.reduce((acc, t) => {
    const norm = t.procento.replace(',', '.');
    if (!/^\d{1,3}([.]\d{1,2})?$/.test(norm)) return acc;
    const [cela = '0', des = ''] = norm.split('.');
    return acc + Number(cela) * 100 + Number((des + '00').slice(0, 2));
  }, 0);
  const cela = Math.floor(soucetSetin / 100);
  const des = soucetSetin % 100;
  return des === 0 ? `${cela}` : `${cela},${des.toString().padStart(2, '0')}`;
}
